var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-docs (1) 2",
    clipPath: "url(#clip0_64_4052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.8089 4.83039L11.0072 1.02865C10.9184 0.939874 10.7973 0.889404 10.6711 0.889404H4.01785C3.23173 0.889404 2.59216 1.52897 2.59216 2.31509V15.6849C2.59216 16.471 3.23173 17.1106 4.01785 17.1106H13.5225C14.3086 17.1106 14.9481 16.471 14.9481 15.6849V5.16648C14.9481 5.0369 14.8938 4.91521 14.8089 4.83039ZM11.1463 2.51194L13.3256 4.69125H11.6215C11.3595 4.69125 11.1463 4.47806 11.1463 4.21602V2.51194ZM13.5225 16.1601H4.01785C3.75581 16.1601 3.54262 15.9469 3.54262 15.6849V2.31509C3.54262 2.05305 3.75581 1.83986 4.01785 1.83986H10.1958V4.21602C10.1958 5.00214 10.8354 5.64171 11.6215 5.64171H13.9977V15.6849C13.9977 15.9469 13.7845 16.1601 13.5225 16.1601Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.6216 7.60608H5.91883C5.65638 7.60608 5.4436 7.81886 5.4436 8.08131C5.4436 8.34376 5.65638 8.55654 5.91883 8.55654H11.6216C11.8841 8.55654 12.0968 8.34376 12.0968 8.08131C12.0968 7.81886 11.8841 7.60608 11.6216 7.60608Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.6216 9.50702H5.91883C5.65638 9.50702 5.4436 9.7198 5.4436 9.98225C5.4436 10.2447 5.65638 10.4575 5.91883 10.4575H11.6216C11.8841 10.4575 12.0968 10.2447 12.0968 9.98225C12.0968 9.7198 11.8841 9.50702 11.6216 9.50702Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.6216 11.4078H5.91883C5.65638 11.4078 5.4436 11.6206 5.4436 11.883C5.4436 12.1455 5.65638 12.3582 5.91883 12.3582H11.6216C11.8841 12.3582 12.0968 12.1455 12.0968 11.883C12.0968 11.6206 11.8841 11.4078 11.6216 11.4078Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.72068 13.3087H5.91883C5.65638 13.3087 5.4436 13.5215 5.4436 13.7839C5.4436 14.0464 5.65638 14.2592 5.91883 14.2592H9.72068C9.98313 14.2592 10.1959 14.0464 10.1959 13.7839C10.1959 13.5215 9.98313 13.3087 9.72068 13.3087Z",
    fill: "#222222"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_4052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.2212,
    height: 16.2212,
    fill: "white",
    transform: "translate(0.659607 0.889404)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsIcon);
export default __webpack_public_path__ + "static/media/documents-icon.7256aa1311381c04f34e5f9c9d4fa61f.svg";
export { ForwardRef as ReactComponent };